export const SMARTYUGIKI = [
  {
    smart_flag: 1,
    smart_flag_mei: 'スマート遊技機のみ'
  },
  {
    smart_flag: 0,
    smart_flag_mei: 'スマート遊技機以外'
  }
];

export default SMARTYUGIKI;
